module.exports = __webpack_public_path__ + "images/home-dingtalk-work/shot-1@2x-9a616b28275e3e32ebb8aaa46ccd1338.png";